/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ApproximateInputs */

const cs_enum_approximate = /** @type {(inputs: Enum_ApproximateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přibližná poloha`)
};

const en_enum_approximate = /** @type {(inputs: Enum_ApproximateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approximate`)
};

/**
* | output |
* | --- |
* | "Approximate" |
*
* @param {Enum_ApproximateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_approximate = /** @type {((inputs?: Enum_ApproximateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ApproximateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_approximate(inputs)
	return cs_enum_approximate(inputs)
});